import React from 'react';
import { Layout, Typography, Collapse, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const faqs = [
    {
        category: 'Opening an Account',
        questions: [
            { 
                question: 'How do I create an account on JectHub?', 
                answer: 'To create an account, visit www.jecthub.com and click on the "Sign Up" button. Fill in the required details, choose your role, and verify your email to activate your account.'
            },
            { 
                question: 'Is JectHub free to join?', 
                answer: 'Yes, JectHub offers free access to students and mentors. However, premium features for recruiters and companies may require a subscription.'
            }
        ]
    },
    {
        category: 'Closing an Account',
        questions: [
            { 
                question: 'How can I delete my JectHub account?', 
                answer: 'To close your account, go to "Account Settings" and select "Delete Account." Follow the instructions to complete the process or contact support@jecthub.com for assistance.'
            },
            { 
                question: 'Can I reactivate my JectHub account after deletion?', 
                answer: 'No, once your account is permanently deleted, all associated data is lost. You will need to create a new account to use JectHub again.'
            }
        ]
    },
    {
        category: 'Account Security',
        questions: [
            { 
                question: 'How do I reset my password?', 
                answer: 'Click on "Forgot Password" on the login page, enter your email, and follow the instructions sent to reset your password.'
            },
            { 
                question: 'How can I enable two-factor authentication (2FA)?', 
                answer: 'Go to "Account Settings" > "Security" and enable 2FA by following the setup process.'
            }
        ]
    },
    {
        category: 'Challenges and Competitions',
        questions: [
            { 
                question: 'How do I participate in a challenge?', 
                answer: 'Navigate to the "Challenges" section, select a challenge, and click "Join Challenge" to participate.'
            },
            { 
                question: 'Are there prizes for winning challenges?', 
                answer: 'Yes, selected challenges have cash prizes, job opportunities, and mentorship benefits for top performers.'
            }
        ]
    },
    {
        category: 'Mentorship and Learning',
        questions: [
            { 
                question: 'How can I find a mentor on JectHub?', 
                answer: 'Go to the "Mentorship" section and browse available mentors. You can send a request to connect with a mentor of your choice.'
            },
            { 
                question: 'Can I become a mentor on JectHub?', 
                answer: 'Yes, experienced professionals can apply to become mentors. Go to "Mentorship" > "Become a Mentor" and complete the application process.'
            }
        ]
    },
    {
        category: 'Platform Usage',
        questions: [
            { 
                question: 'How do I submit a project on JectHub?', 
                answer: 'Navigate to "Projects" > "Submit Project" and upload your files along with a description of your work.'
            },
            { 
                question: 'What types of projects can I submit?', 
                answer: 'You can submit AI, cybersecurity, and data science-related projects, as well as general software development projects.'
            }
        ]
    }
];

function JectHubFAQs() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Frequently Asked Questions (FAQs)</Title>
                {faqs.map((section, index) => (
                    <div key={index} style={{ marginBottom: '40px' }}>
                        <Title level={3}>{section.category}</Title>
                        <Row gutter={[16, 16]}>
                            {section.questions.map((q, qIndex) => (
                                <Col xs={24} sm={12} key={qIndex}>
                                    <Collapse accordion>
                                        <Panel header={q.question}>
                                            <Paragraph>{q.answer}</Paragraph>
                                        </Panel>
                                    </Collapse>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
                {/* CSS to reduce font sizes within Ant Design Typography */}
                <style jsx global>{`
                    h2.ant-typography {
                        font-size: 22px !important; /* Reduced from ~32px to 28px */
                    }
                    h3.ant-typography {
                        font-size: 18px !important; /* Already reduced from ~24px to 20px */
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default JectHubFAQs;